// extracted by mini-css-extract-plugin
export default {"container":"LayeredAnimation-module--container--NOPuU","layerContainer":"LayeredAnimation-module--layerContainer--H67rR"};